// if (!customElements.get("product-form")) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector("form");

//         // Safeguard: ensure variantIdInput exists before accessing it
//         const variantInput = this.variantIdInput;
//         if (variantInput) {
//           variantInput.disabled = false;
//         }

//         this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

//         // Prioritize cart-drawer over cart-notification
//         this.cart =
//           document.querySelector("cart-drawer") ||
//           document.querySelector("cart-notification");

//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton?.querySelector("span");

//         if (document.querySelector("cart-drawer"))
//           this.submitButton?.setAttribute("aria-haspopup", "dialog");

//         this.hideErrors = this.dataset.hideErrors === "true";
//         // Sync variant IDs removed: handled by product-info.js updateVariantInputs()
//         // which triggers 'change' on all .product-variant-id within the same product section.
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();

//         // Robust modal detection (loop + dataset fallback)
//         let isModalSubmit = false;
//         // Check dataset flag first (for manual/console)
//         if (this.form.dataset.isModalSubmit === "true") {
//           isModalSubmit = true;
//         } else {
//           // Fallback: Walk up parents
//           let parent = this.form.parentElement;
//           while (parent) {
//             if (
//               parent.tagName === "MODAL-DIALOG" &&
//               parent.id.startsWith("StickyVariantModal-")
//             ) {
//               isModalSubmit = true;
//               break;
//             }
//             parent = parent.parentElement;
//           }
//         }

//         const context = this.closest("product-info") || document;
        
//         const sizePicker = context.querySelector('.size-picker');
//         const hasSizePicker = sizePicker !== null;
//         const selectedSize = hasSizePicker ? sizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)') : null;

//         const lengthPicker = context.querySelector('.length-picker');
//         const hasLengthPicker = lengthPicker !== null;
//         const selectedLength = hasLengthPicker ? lengthPicker.querySelector('input[type="radio"]:checked') : null;

//         const sizeErrorEl = context.querySelector(".product-form__error-message-wrapper-variant");

//         if (hasSizePicker && !selectedSize) {
//           if (sizeErrorEl) {
//             sizeErrorEl.style.display = "block";
//             const span = sizeErrorEl.querySelector("span");
//             if (span) span.textContent = "Select Size";
//           }
//           this.submitButton.removeAttribute("aria-disabled");
//           const spinner = this.querySelector(".loading__spinner");
//           if (spinner) spinner.classList.add("hidden");
//           return;
//         }

//         if (hasLengthPicker && !selectedLength) {
//           if (sizeErrorEl) {
//             sizeErrorEl.style.display = "block";
//             const span = sizeErrorEl.querySelector("span");
//             if (span) span.textContent = "Select Length";
//           }
//           this.submitButton.removeAttribute("aria-disabled");
//           const spinner = this.querySelector(".loading__spinner");
//           if (spinner) spinner.classList.add("hidden");
//           return;
//         }

//         if (this.submitButton.getAttribute("aria-disabled") === "true") return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");
//         const spinner = this.querySelector(".loading__spinner");
//         if (spinner) spinner.classList.remove("hidden");

//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         const baseFormData = new FormData(this.form);
//         const quantitySelect =
//           this.form.querySelector('select[name="quantity"]') ||
//           document.querySelector('select[name="quantity"]');

//         let wasDisabled = false;
//         if (quantitySelect && quantitySelect.disabled) {
//           quantitySelect.disabled = false;
//           wasDisabled = true;
//         }

//         if (wasDisabled && quantitySelect) {
//           quantitySelect.disabled = true;
//         }

//         let quantityRaw = baseFormData.get("quantity");

//         if (quantityRaw === null) {
//           const quantitySelect =
//             this.form.querySelector('select[name="quantity"]') ||
//             document.querySelector('select[name="quantity"]');
//           if (quantitySelect) {
//             quantityRaw = quantitySelect.value;
//           }
//         }

//         let quantity = parseInt(quantityRaw, 10);

//         if (isNaN(quantity) || quantity <= 0) {
//           quantity = 1;
//         }

//         const sections =
//           typeof this.cart?.getSectionsToRender === "function"
//             ? this.cart.getSectionsToRender().map((section) => section.id)
//             : ["cart-drawer", "cart-icon-bubble"];

//         const getLocalePrefix = () => {
//           const path = window.location.pathname;
//           const match = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)/);
//           return match ? "/" + match[1] : "";
//         };

//         const addSingleItem = async () => {
//           const formData = new FormData();
//           for (let [key, value] of baseFormData.entries()) {
//             if (key !== "quantity") formData.append(key, value);
//           }

//           formData.append("quantity", 1);
//           formData.append("sections", sections.join(","));
//           formData.append("sections_url", window.location.pathname);
//           formData.append("properties[_unique_id]", crypto.randomUUID());

//           const res = await fetch("/cart/add.js", {
//             method: "POST",
//             body: formData,
//             headers: {
//               "X-Requested-With": "XMLHttpRequest",
//             },
//           });

//           if (!res.ok) {
//             const errorData = await res.json();
//             throw new Error(errorData?.description || "Add to cart failed");
//           }

//           await updateCustomerCartMetafield();
//           return res.json();
//         };

//         const renderCartContents = async () => {
//           const cartData = await fetch("/cart.js").then((res) => res.json());
//           sessionStorage.setItem("cart_trial", JSON.stringify(cartData));
//           //await updateCustomerCartMetafield();
//           // Mobile/Tablet behavior (≤1024px)
//           // if (window.innerWidth <= 1024) {
//           //   const notification = document.getElementById(
//           //     "AddedToBagNotification"
//           //   );
//           //   if (notification) {
//           //     notification.classList.remove("hidden");

//           //     setTimeout(() => {
//           //       notification.classList.add("hidden");
//           //     }, 3000);
//           //   }

//           //   // Still update cart bubble
//           //   try {
//           //     const sectionsData = await fetch(
//           //         `${getLocalePrefix()}/?sections=cart-icon-bubble`
//           //     ).then((res) => res.json());

//           //     const bubble = document.querySelector("#cart-icon-bubble");
//           //     if (bubble && sectionsData["cart-icon-bubble"]) {
//           //       const parsedBubble = new DOMParser()
//           //         .parseFromString(
//           //           sectionsData["cart-icon-bubble"],
//           //           "text/html"
//           //         )
//           //         .querySelector(".shopify-section");
//           //       if (parsedBubble) {
//           //         bubble.innerHTML = parsedBubble.innerHTML;
//           //       }
//           //     }
//           //   } catch (e) {
//           //     console.error("Error updating cart bubble:", e);
//           //   }

//           //   return; // stop here (don’t open cart-drawer)
//           // }

//           if (window.innerWidth <= 1024 || isModalSubmit) {
//             // Treat modal as "mobile-like" (notification only, no drawer/redirect)
//             const notification = document.getElementById(
//               "AddedToBagNotification",
//             );

//             // Detect ?app-view=true
//             const urlParams = new URLSearchParams(window.location.search);
//             const isAppView = urlParams.get("app-view") === "true";

//             if (isAppView) {
//               // Remove existing modal if any
//               if (notification) notification.classList.add("hidden");

//               // Create the app-view style flyout
//               const existingFlyout = document.querySelector(
//                 ".app-view-add-to-bag-flyout",
//               );
//               if (existingFlyout) existingFlyout.remove();

//               const flyout = document.createElement("div");
//               flyout.className = "app-view-add-to-bag-flyout";
//               flyout.innerHTML = `
//       <div class="flyout-text">Item Added</div>
//       <a href="/cart?app-view=true" class="flyout-btn">VIEW BAG </a>
//     `;
//               document.body.appendChild(flyout);

//               // Auto-hide after 3s
//               setTimeout(() => {
//                 flyout.remove();
//               }, 3000);
//             } else {
//               // Default existing modal behavior
//               if (notification) {
//                 notification.classList.remove("hidden");
//                 setTimeout(() => {
//                   notification.classList.add("hidden");
//                 }, 3000);
//               }
//             }

//             // Still update cart bubble as before
//             try {
//               const sectionsData = await fetch(
//                 `${getLocalePrefix()}/?sections=cart-icon-bubble`,
//               ).then((res) => res.json());
//               const bubble = document.querySelector("#cart-icon-bubble");
//               if (bubble && sectionsData["cart-icon-bubble"]) {
//                 const parsedBubble = new DOMParser()
//                   .parseFromString(
//                     sectionsData["cart-icon-bubble"],
//                     "text/html",
//                   )
//                   .querySelector(".shopify-section");
//                 if (parsedBubble) {
//                   bubble.innerHTML = parsedBubble.innerHTML;
//                 }
//               }
//             } catch (e) {
//               console.error("Error updating cart bubble:", e);
//             }

//             return; // Always stop here for modal (no drawer attempt, no redirect)
//           }

//           // Desktop behavior (>1024px) → cart-drawer as usual (only for non-modal)
//           const sectionsData = await fetch(
//             `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`,
//           ).then((res) => res.json());

//           if (this.cart && typeof this.cart.renderContents === "function") {
//             try {
//               this.cart.renderContents({
//                 items: cartData.items,
//                 sections: sectionsData,
//                 total_price: cartData.total_price,
//               });
//             } catch (e) {
//               console.error("Error rendering cart contents:", e);
//               // For non-modal only, fallback to redirect on render error
//               if (!isModalSubmit) {
//                 window.location.href = "/cart";
//               }
//             }
//           }

//           if (
//             this.cart &&
//             this.cart.tagName.toLowerCase() === "cart-drawer" &&
//             typeof this.cart.open === "function"
//           ) {
//             try {
//               this.cart.open(this.submitButton);
//               this.cart.classList.add("animate", "active");
//               this.cart.style.display = "block";
//               this.cart.style.visibility = "visible";
//             } catch (e) {
//               console.error("Error opening cart drawer:", e);
//               // For non-modal only, fallback to redirect on open error
//               if (!isModalSubmit) {
//                 window.location.href = "/cart";
//               }
//             }
//           } else {
//             // fallback
//             try {
//               const bubble = document.querySelector("#cart-icon-bubble");
//               if (bubble && sectionsData["cart-icon-bubble"]) {
//                 bubble.dispatchEvent(new Event("click", { bubbles: true }));
//               } else {
//                 // For non-modal only, fallback to redirect
//                 if (!isModalSubmit) {
//                   window.location.href = "/cart";
//                 }
//               }
//             } catch (e) {
//               console.error("Error triggering cart bubble:", e);
//               // For non-modal only, fallback to redirect
//               if (!isModalSubmit) {
//                 window.location.href = "/cart";
//               }
//             }
//           }
//         };

//         (async () => {
//           try {
//             let sectionsData = {};
//             for (let i = 0; i < quantity; i++) {
//               const response = await addSingleItem();
//               if (response.sections) {
//                 sectionsData = { ...sectionsData, ...response.sections };
//               }
//             }

//             const quickAddModal = this.closest("quick-add-modal");
//             const stickyVariantModal = isModalSubmit
//               ? this.closest('modal-dialog[id^="StickyVariantModal-"]')
//               : null; // Detect sticky modal specifically

//             if (quickAddModal) {
//               // Existing quick-add logic (unchanged - hides modal and waits for close event)
//               document.body.addEventListener(
//                 "modalClosed",
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure(
//                       "add:paint-updated-sections",
//                       renderCartContents,
//                     );
//                   });
//                 },
//                 { once: true },
//               );
//               quickAddModal.hide(true);
//             } else if (stickyVariantModal) {

//               const onModalHidden = () => {
//                 setTimeout(() => {
//                   CartPerformance.measure(
//                     "add:paint-updated-sections",
//                     renderCartContents,
//                   );
//                 });
//               };

//               // Listen for 'modalClosed' event if your modal dispatches it
//               document.body.addEventListener("modalClosed", onModalHidden, {
//                 once: true,
//               });

//               // Reliable fallback: MutationObserver watches for 'open' attribute removal (modal hidden)
//               const observer = new MutationObserver((mutations) => {
//                 mutations.forEach((mutation) => {
//                   if (
//                     mutation.attributeName === "open" &&
//                     !stickyVariantModal.hasAttribute("open")
//                   ) {
//                     onModalHidden();
//                     observer.disconnect(); // Clean up
//                   }
//                 });
//               });
//               observer.observe(stickyVariantModal, { attributes: true });

//               // Trigger modal hide/close
//               if (stickyVariantModal.hide) {
//                 stickyVariantModal.hide(true); // Preferred if custom element supports it
//               } else {
//                 // Fallback: Simulate close button click or direct DOM manipulation
//                 const closeButton =
//                   stickyVariantModal.querySelector(
//                     "#ModalClose-sticky-{{ section.id }}",
//                   ) ||
//                   stickyVariantModal.querySelector(
//                     ".sticky-variant-modal__toggle",
//                   );
//                 if (closeButton) {
//                   closeButton.click();
//                 } else {
//                   stickyVariantModal.removeAttribute("open");
//                   stickyVariantModal.classList.add("hidden");
//                   document.body.classList.remove("overflow-hidden"); // If your theme uses this for body lock
//                 }
//               }
//             } else {
//               CartPerformance.measure(
//                 "add:paint-updated-sections",
//                 renderCartContents,
//               );
//             }
//           } catch (error) {
//             console.error("Add to cart failed:", error);

//             // Keep default error handling (if not hidden by data-hide-errors)
//             this.handleErrorMessage(error.message || "Failed to add item.");

//             // ─── NEW: Show error in Sticky modal if this submit is from there ───────
//             const modal = this.closest(
//               'modal-dialog[id^="StickyVariantModal-"]',
//             );
//             if (modal && isModalSubmit) {
//               // extra safety check
//               // Preferred: your custom sticky error element
//               const stickyError = modal.querySelector(".sticky-error-message");
//               if (stickyError) {
//                 stickyError.textContent =
//                   error.message ||
//                   "Sorry, could not add this item. Please try again.";
//                 stickyError.style.display = "block";
//               }

//               // Fallback / additional: standard product form error wrapper
//               const errorWrapper = modal.querySelector(
//                 ".product-form__error-message-wrapper",
//               );
//               if (errorWrapper) {
//                 errorWrapper.removeAttribute("hidden");
//                 errorWrapper.style.display = "block"; // in case it's styled hidden

//                 const errorMsg = errorWrapper.querySelector(
//                   ".product-form__error-message",
//                 );
//                 if (errorMsg) {
//                   errorMsg.textContent = error.message || "Failed to add item.";
//                 }
//               }

//               // IMPORTANT: Do NOT close modal on error
//               // (your existing delay/close code is only in success path)
//             }

//             // Only unlock body scroll for non-modal cases
//             if (!isModalSubmit) {
//               document.body.classList.remove("overflow-hidden");
//             }
//           } finally {
//             this.submitButton.classList.remove("loading");
//             if (this.cart && this.cart.classList.contains("is-empty")) {
//               this.cart.classList.remove("is-empty");
//             }
//             this.submitButton.removeAttribute("aria-disabled");
//             const spinner = this.querySelector(".loading__spinner");
//             if (spinner) spinner.classList.add("hidden");
//             CartPerformance.measureFromEvent("add:user-action", evt);
//           }
//         })();
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message",
//           );

//         this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         const allButtons = document.querySelectorAll(
//           'product-form button[type="submit"]',
//         );

//         allButtons.forEach((button) => {
//           if (disable) {
//             button.setAttribute("disabled", "disabled");
//             if (text) {
//               const span = button.querySelector("span");
//               if (span) span.textContent = text;
//             }
//           } else {
//             button.removeAttribute("disabled");
//             const span = button.querySelector("span");
//             if (span) span.textContent = window.variantStrings.addToCart;
//           }
//         });
//       }

//       // Utility method: Check if all variants are selected (scoped to context)
//       isAllVariantsSelected(context = document) {
//         if (context === document)
//           context = this.closest("product-info") || document;
//         const selectedSize = context.querySelector(
//           '.size-picker input[type="radio"]:checked:not(.toggle-radio)',
//         );
//         const selectedLength = context.querySelector(
//           '.length-picker input[type="radio"]:checked',
//         );
//         const sellength = context.querySelector(
//           '.length-picker input[type="radio"]',
//         );
//         if (!context.querySelector(".size-picker")) return true;
//         if (!selectedSize) {
//           return false;
//         }
//         if (sellength && !selectedLength) {
//           return false;
//         }
//         const selectedColor = context.querySelector(
//           '.color-picker input[type="radio"]:checked',
//         );
//         if (context.querySelector(".color-picker") && !selectedColor) {
//           return false;
//         }
//         return true;
//       }

//       get variantIdInput() {
//         return this.form.querySelector("[name=id]");
//       }
//     },
//   );
// }

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        // Safeguard: ensure variantIdInput exists before accessing it
        const variantInput = this.variantIdInput;
        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        // Prioritize cart-drawer over cart-notification
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        // Sync variant IDs removed: handled by product-info.js updateVariantInputs()
        // which triggers 'change' on all .product-variant-id within the same product section.
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Robust modal detection (loop + dataset fallback)
        let isModalSubmit = false;
        // Check dataset flag first (for manual/console)
        if (this.form.dataset.isModalSubmit === "true") {
          isModalSubmit = true;
        } else {
          // Fallback: Walk up parents
          let parent = this.form.parentElement;
          while (parent) {
            if (
              parent.tagName === "MODAL-DIALOG" &&
              parent.id.startsWith("StickyVariantModal-")
            ) {
              isModalSubmit = true;
              break;
            }
            parent = parent.parentElement;
          }
        }

        const context = this.closest("product-info") || document;
        
        const sizePicker = context.querySelector('.size-picker');
        const hasSizePicker = sizePicker !== null;
        const selectedSize = hasSizePicker ? sizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)') : null;

        const lengthPicker = context.querySelector('.length-picker');
        const hasLengthPicker = lengthPicker !== null;
        const selectedLength = hasLengthPicker ? lengthPicker.querySelector('input[type="radio"]:checked') : null;

        const sizeErrorEl = context.querySelector(".product-form__error-message-wrapper-variant");

        if (hasSizePicker && !selectedSize) {
          if (sizeErrorEl) {
            sizeErrorEl.removeAttribute("hidden");
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Size";
          }
          this.submitButton.removeAttribute("aria-disabled");
          const spinner = this.querySelector(".loading__spinner");
          if (spinner) spinner.classList.add("hidden");
          return;
        }

        if (hasLengthPicker && !selectedLength) {
          if (sizeErrorEl) {
            sizeErrorEl.removeAttribute("hidden");
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Length";
          }
          this.submitButton.removeAttribute("aria-disabled");
          const spinner = this.querySelector(".loading__spinner");
          if (spinner) spinner.classList.add("hidden");
          return;
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const getScopeRoots = () =>
          [
            this.closest("modal-dialog"),
            this.closest("quick-add-modal"),
            this.closest("product-info"),
            this,
            context,
            document,
          ].filter((root, index, roots) => root && roots.indexOf(root) === index);

        const getFormBoundField = (selector) => {
          const formId = this.form?.id;

          if (this.form?.querySelector(selector)) {
            return this.form.querySelector(selector);
          }

          for (const root of getScopeRoots()) {
            if (formId) {
              const formBoundField = root.querySelector(
                `${selector}[form="${formId}"]`
              );
              if (formBoundField) return formBoundField;
            }

            const fallbackField = root.querySelector(selector);
            if (fallbackField) return fallbackField;
          }

          return null;
        };

        const quantityField = getFormBoundField('[name="quantity"]');
        const baseFormData = new FormData(this.form);

        let wasDisabled = false;
        if (quantityField && quantityField.disabled) {
          quantityField.disabled = false;
          wasDisabled = true;
        }

        if (wasDisabled && quantityField) {
          quantityField.disabled = true;
        }

        let quantityRaw = baseFormData.get("quantity");

        if (quantityRaw === null) {
          if (quantityField) {
            quantityRaw = quantityField.value;
          }
        }

        let quantity = parseInt(quantityRaw, 10);

        if (isNaN(quantity) || quantity <= 0) {
          quantity = 1;
        }

        const sections =
          typeof this.cart?.getSectionsToRender === "function"
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : ["cart-drawer", "cart-icon-bubble"];

        const getLocalePrefix = () => {
          const path = window.location.pathname;
          const match = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)/);
          return match ? "/" + match[1] : "";
        };

        const TOO_MANY_REQUESTS_MESSAGE =
          "Too many requests. Please reload the page and try again.";
        const MAX_SAME_VARIANT_LIMIT = 10;
        const MAX_VARIANT_IN_CART_MESSAGE_PATTERN =
          /maximum quantity of this item is already in your cart/i;
        const TOO_MANY_REQUESTS_RELOAD_DELAY_MS = 50;
        const TOO_MANY_REQUESTS_FALLBACK_MESSAGE_DELAY_MS = 2500;
        const TOO_MANY_REQUESTS_RELOAD_COOLDOWN_MS = 15000;
        const TOO_MANY_REQUESTS_RELOAD_GUARD_KEY =
          "product-form-too-many-requests-reload-at";
        let rateLimitReloadScheduled = false;

        const parseEmbeddedJson = (selector) => {
          // OPTIMIZATION: Cache parsed JSON results to avoid expensive re-parsing on every click
          this._cachedJson = this._cachedJson || {};
          if (this._cachedJson[selector]) return this._cachedJson[selector];

          for (const root of getScopeRoots()) {
            const source = root.querySelector(selector);
            if (!source?.textContent) continue;

            try {
              const parsed = JSON.parse(source.textContent);
              this._cachedJson[selector] = parsed;
              return parsed;
            } catch (parseError) {
              console.error(
                `[CART-DEBUG] Failed parsing embedded JSON for selector "${selector}"`,
                parseError
              );
            }
          }

          return null;
        };

        const getRenderedQuantityLimit = () => {
          if (!quantityField) return null;

          if (quantityField.tagName === "SELECT") {
            const optionValues = Array.from(quantityField.options || [])
              .map((option) => Number(option.value))
              .filter((value) => Number.isFinite(value) && value > 0);

            if (optionValues.length) {
              return Math.max(...optionValues);
            }

            const stockLimit = Number(quantityField.dataset.stock);
            if (Number.isFinite(stockLimit) && stockLimit > 0) {
              return Math.min(MAX_SAME_VARIANT_LIMIT, stockLimit);
            }
          }

          const explicitMax = Number(
            quantityField.getAttribute("max") || quantityField.dataset.max
          );

          return Number.isFinite(explicitMax) && explicitMax > 0
            ? explicitMax
            : null;
        };

        const getSelectedVariantData = () => {
          const currentVariantId = this.variantIdInput?.value;
          const selectedVariant = parseEmbeddedJson(
            "variant-selects [data-selected-variant]"
          );

          if (
            selectedVariant &&
            (!currentVariantId ||
              String(selectedVariant.id) === String(currentVariantId))
          ) {
            return selectedVariant;
          }

          const allVariants =
            parseEmbeddedJson("variant-selects [data-product-variants]") || [];

          return (
            allVariants.find(
              (variant) => String(variant.id) === String(currentVariantId)
            ) || selectedVariant
          );
        };

        const getSameVariantPurchaseLimitDetails = () => {
          const selectedVariant = getSelectedVariantData();
          let limit = null;
          let hasExplicitQuantityRuleMax = false;

          if (!selectedVariant) {
            limit = getRenderedQuantityLimit() || MAX_SAME_VARIANT_LIMIT;
            return {
              limit: Number.isFinite(limit) && limit > 0 ? limit : null,
              hasExplicitQuantityRuleMax,
            };
          }

          const quantityRuleMax = Number(selectedVariant?.quantity_rule?.max);
          const inventoryQuantity = Number(selectedVariant?.inventory_quantity);
          const shouldUseInventoryLimit =
            selectedVariant.inventory_management === "shopify" &&
            selectedVariant.inventory_policy !== "continue" &&
            Number.isFinite(inventoryQuantity);

          if (Number.isFinite(quantityRuleMax) && quantityRuleMax > 0) {
            limit = quantityRuleMax;
            hasExplicitQuantityRuleMax = true;
          }

          if (shouldUseInventoryLimit) {
            const normalizedInventoryLimit = Math.max(inventoryQuantity, 0);
            limit =
              Number.isFinite(limit) && limit > 0
                ? Math.min(limit, normalizedInventoryLimit)
                : normalizedInventoryLimit;
          }

          return {
            limit: Number.isFinite(limit) && limit > 0 ? limit : null,
            hasExplicitQuantityRuleMax,
          };
        };

        const getCurrentVariantCartQuantity = async (preFetchedCartData = null) => {
          const currentVariantId = String(this.variantIdInput?.value || "");
          if (!currentVariantId) return 0;

          const getVariantQuantityFromCart = (cartData) =>
            (cartData?.items || [])
              .filter((item) => String(item?.id) === currentVariantId)
              .reduce(
                (total, item) => total + (Number(item?.quantity) || 0),
                0
              );

          if (preFetchedCartData) {
            return getVariantQuantityFromCart(preFetchedCartData);
          }

          try {
            const storedCart = sessionStorage.getItem("cart_trial");
            if (storedCart) {
              return getVariantQuantityFromCart(JSON.parse(storedCart));
            }
          } catch (storageError) {
            console.warn(
              "[CART-DEBUG] Failed reading cart_trial from sessionStorage",
              storageError
            );
          }

          try {
            const cartResponse = await fetch("/cart.js", {
              headers: { "X-Requested-With": "XMLHttpRequest" },
            });
            const cartContentType =
              cartResponse.headers.get("content-type") || "";

            if (!cartResponse.ok || cartContentType.includes("text/html")) {
              return 0;
            }

            const cartData = await cartResponse.json();
            sessionStorage.setItem("cart_trial", JSON.stringify(cartData));
            return getVariantQuantityFromCart(cartData);
          } catch (cartQuantityError) {
            console.warn(
              "[CART-DEBUG] Failed fetching cart quantity for current variant",
              cartQuantityError
            );
          }

          return 0;
        };

        const getFriendlyMaxQuantityMessage = async (preFetchedCartData = null) => {
          const { limit, hasExplicitQuantityRuleMax } =
            getSameVariantPurchaseLimitDetails();
          const cartQuantity = await getCurrentVariantCartQuantity(
            preFetchedCartData
          );

          let displayLimit = limit;

          if (
            !hasExplicitQuantityRuleMax &&
            Number.isFinite(cartQuantity) &&
            cartQuantity > 0
          ) {
            displayLimit = Math.max(displayLimit || 0, cartQuantity);
          }

          if (!displayLimit) return null;

          return `We're sorry, you are limited to ${displayLimit} of this item in the same color and size.`;
        };

        const isRateLimitedOrCloudflareVerification = (
          status,
          rawText = ""
        ) =>
          status === 429 ||
          /too many requests|rate limit|temporarily unavailable|verifying your connection|connection needs to be verified|cdn-cgi\/challenge-platform|cf_chl_opt/i.test(
            rawText
          );

        const scheduleRateLimitReload = () => {
          rateLimitReloadScheduled = false;

          if (typeof window === "undefined") return false;

          let lastReloadAt = 0;
          try {
            lastReloadAt = Number(
              window.sessionStorage?.getItem(
                TOO_MANY_REQUESTS_RELOAD_GUARD_KEY
              )
            );
          } catch (storageError) {
            console.warn(
              "[CART-DEBUG] Failed reading rate-limit reload guard",
              storageError
            );
          }

          const now = Date.now();
          if (
            Number.isFinite(lastReloadAt) &&
            now - lastReloadAt < TOO_MANY_REQUESTS_RELOAD_COOLDOWN_MS
          ) {
            return false;
          }

          try {
            window.sessionStorage?.setItem(
              TOO_MANY_REQUESTS_RELOAD_GUARD_KEY,
              String(now)
            );
          } catch (storageError) {
            console.warn(
              "[CART-DEBUG] Failed storing rate-limit reload guard",
              storageError
            );
          }

          rateLimitReloadScheduled = true;
          window.setTimeout(() => {
            window.location.reload();
          }, TOO_MANY_REQUESTS_RELOAD_DELAY_MS);

          return true;
        };

        const getFriendlyCartErrorMessage = async (
          response,
          fallbackMessage,
          preloadedRawText = ""
        ) => {
          const status = Number(response?.status) || 0;
          const contentType = response?.headers?.get("content-type") || "";
          let rawText = preloadedRawText;
          let errorData = null;

          if (!rawText && response?.clone) {
            try {
              rawText = await response.clone().text();
            } catch (readError) {
              console.error(
                "[CART-DEBUG] Failed reading response text for error handling",
                readError
              );
            }
          }

          if (isRateLimitedOrCloudflareVerification(status, rawText)) {
            scheduleRateLimitReload();
            return TOO_MANY_REQUESTS_MESSAGE;
          }

          if (!contentType.includes("text/html")) {
            try {
              errorData = await response.clone().json();
            } catch (parseErr) {
              console.error(
                "[CART-DEBUG] Failed to parse JSON error response",
                parseErr
              );
            }
          }

          const combinedErrorText = [
            errorData?.description,
            errorData?.message,
            rawText,
          ]
            .filter(Boolean)
            .join(" ");

          if (
            status === 422 &&
            MAX_VARIANT_IN_CART_MESSAGE_PATTERN.test(combinedErrorText)
          ) {
            return (
              (await getFriendlyMaxQuantityMessage()) || fallbackMessage
            );
          }

          if (errorData) {
            return errorData?.description || errorData?.message || fallbackMessage;
          }

          return fallbackMessage;
        };

        const fetchCartState = async () => {
          console.log("[CART-DEBUG] fetchCartState: GET /cart.js started");
          const cartResponse = await fetch("/cart.js");
          const cartContentType =
            cartResponse.headers.get("content-type") || "unknown";
          console.log(
            `[CART-DEBUG] fetchCartState: GET /cart.js responded status=${cartResponse.status} content-type="${cartContentType}"`
          );

          if (!cartResponse.ok || cartContentType.includes("text/html")) {
            const rawBody = await cartResponse.text();
            console.error(
              `[CART-DEBUG] fetchCartState: Error or HTML from /cart.js (status=${cartResponse.status}). First 200 chars:`,
              rawBody.substring(0, 200)
            );
            throw new Error(
              await getFriendlyCartErrorMessage(
                cartResponse,
                `Cart fetch failed (HTTP ${cartResponse.status})`,
                rawBody
              )
            );
          }

          return cartResponse.json();
        };

        const addItems = async (requestedQuantity) => {
          const formData = new FormData();
          for (let [key, value] of baseFormData.entries()) {
            if (key !== "quantity") formData.append(key, value);
          }

          const requestUniqueId = crypto.randomUUID();

          formData.append("quantity", requestedQuantity);
          formData.append("sections", sections.join(","));
          formData.append("sections_url", window.location.pathname);
          formData.append("properties[_unique_id]", requestUniqueId);

          const _t0 = performance.now();
          console.log(
            `[CART-DEBUG] addItems: POST /cart/add.js started quantity=${requestedQuantity}`
          );
          const res = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          });
          const _t1 = performance.now();
          const _ct = res.headers.get("content-type") || "unknown";
          console.log(
            `[CART-DEBUG] addItems: POST /cart/add.js responded status=${res.status} content-type="${_ct}" time=${(_t1 - _t0).toFixed(0)}ms`
          );

          if (!res.ok) {
            let errorDescription = `Add to cart failed (HTTP ${res.status})`;
            let rawText = "";
            if (_ct.includes("text/html")) {
              rawText = await res.clone().text();
              console.error(
                `[CART-DEBUG] addItems: Non-JSON error response (status=${res.status}, content-type="${_ct}"). First 200 chars:`,
                rawText.substring(0, 200)
              );
            }
            errorDescription = await getFriendlyCartErrorMessage(
              res,
              errorDescription,
              rawText
            );

            if (Number(res.status) === 422) {
              try {
                const cartData = await fetchCartState();
                const addedLineItem = cartData?.items?.find(
                  (item) =>
                    String(item?.properties?._unique_id || "") ===
                    requestUniqueId
                );
                const addedQuantity = Number(addedLineItem?.quantity) || 0;

                if (addedQuantity > 0) {
                  console.warn(
                    `[CART-DEBUG] addItems: partial add recovered quantity=${addedQuantity}/${requestedQuantity} uniqueId=${requestUniqueId}`
                  );

                  return {
                    cartData,
                    partialAddMessage: errorDescription,
                    requestedQuantity,
                    addedQuantity,
                  };
                }
              } catch (partialRecoveryError) {
                console.error(
                  "[CART-DEBUG] addItems: failed checking cart state for partial add recovery",
                  partialRecoveryError
                );
              }
            }

            throw new Error(errorDescription);
          }

          return {
            cartData: null,
            partialAddMessage: null,
            responseData: await res.json(),
          };
        };

        const renderCartContents = async (preFetchedCartData = null) => {
          const cartData = preFetchedCartData || (await fetchCartState());
          sessionStorage.setItem("cart_trial", JSON.stringify(cartData));
          //await updateCustomerCartMetafield();
          // Mobile/Tablet behavior (≤1024px)
          // if (window.innerWidth <= 1024) {
          //   const notification = document.getElementById(
          //     "AddedToBagNotification"
          //   );
          //   if (notification) {
          //     notification.classList.remove("hidden");

          //     setTimeout(() => {
          //       notification.classList.add("hidden");
          //     }, 3000);
          //   }

          //   // Still update cart bubble
          //   try {
          //     const sectionsData = await fetch(
          //         `${getLocalePrefix()}/?sections=cart-icon-bubble`
          //     ).then((res) => res.json());

          //     const bubble = document.querySelector("#cart-icon-bubble");
          //     if (bubble && sectionsData["cart-icon-bubble"]) {
          //       const parsedBubble = new DOMParser()
          //         .parseFromString(
          //           sectionsData["cart-icon-bubble"],
          //           "text/html"
          //         )
          //         .querySelector(".shopify-section");
          //       if (parsedBubble) {
          //         bubble.innerHTML = parsedBubble.innerHTML;
          //       }
          //     }
          //   } catch (e) {
          //     console.error("Error updating cart bubble:", e);
          //   }

          //   return; // stop here (don’t open cart-drawer)
          // }

          if (window.innerWidth <= 1024 || isModalSubmit) {
            // Treat modal as "mobile-like" (notification only, no drawer/redirect)
            const notification = document.getElementById(
              "AddedToBagNotification",
            );

            // Detect ?app-view=true
            const urlParams = new URLSearchParams(window.location.search);
            const isAppView = urlParams.get("app-view") === "true";

            if (isAppView) {
              // Remove existing modal if any
              if (notification) notification.classList.add("hidden");

              // Create the app-view style flyout
              const existingFlyout = document.querySelector(
                ".app-view-add-to-bag-flyout",
              );
              if (existingFlyout) existingFlyout.remove();

              const flyout = document.createElement("div");
              flyout.className = "app-view-add-to-bag-flyout";
              flyout.innerHTML = `
      <div class="flyout-text">Item Added</div>
      <a href="/cart?app-view=true" class="flyout-btn">VIEW BAG </a>
    `;
              document.body.appendChild(flyout);

              // Auto-hide after 3s
              setTimeout(() => {
                flyout.remove();
              }, 3000);
            } else {
              // Default existing modal behavior
              if (notification) {
                notification.classList.remove("hidden");
                setTimeout(() => {
                  notification.classList.add("hidden");
                }, 3000);
              }
            }

            // Still update cart bubble as before
            try {
              console.log("[CART-DEBUG] renderCartContents(mobile): GET sections=cart-icon-bubble");
              const _bubbleRes = await fetch(
                `${getLocalePrefix()}/?sections=cart-icon-bubble`,
              );
              const _bubbleCt = _bubbleRes.headers.get("content-type") || "unknown";
              console.log(`[CART-DEBUG] renderCartContents(mobile): sections responded status=${_bubbleRes.status}`);
              if (!_bubbleRes.ok || _bubbleCt.includes("text/html")) {
                const _rawBubble = await _bubbleRes.text();
                console.error(`[CART-DEBUG] renderCartContents(mobile): Non-OK sections response. First 200 chars:`, _rawBubble.substring(0, 200));
                throw new Error(
                  await getFriendlyCartErrorMessage(
                    _bubbleRes,
                    `Sections fetch failed (HTTP ${_bubbleRes.status})`,
                    _rawBubble
                  )
                );
              }
              const sectionsData = await _bubbleRes.json();
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                const parsedBubble = new DOMParser()
                  .parseFromString(
                    sectionsData["cart-icon-bubble"],
                    "text/html",
                  )
                  .querySelector(".shopify-section");
                if (parsedBubble) {
                  bubble.innerHTML = parsedBubble.innerHTML;
                }
              }
            } catch (e) {
              console.error("Error updating cart bubble:", e);
            }

            return; // Always stop here for modal (no drawer attempt, no redirect)
          }

          // Desktop behavior (>1024px) → cart-drawer as usual (only for non-modal)
          console.log("[CART-DEBUG] renderCartContents(desktop): GET sections=cart-drawer,cart-icon-bubble");
          const _deskRes = await fetch(
            `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`,
          );
          const _deskCt = _deskRes.headers.get("content-type") || "unknown";
          console.log(`[CART-DEBUG] renderCartContents(desktop): sections responded status=${_deskRes.status}`);
          if (!_deskRes.ok || _deskCt.includes("text/html")) {
            const _rawDesk = await _deskRes.text();
            console.error(`[CART-DEBUG] renderCartContents(desktop): Non-OK sections response. First 200 chars:`, _rawDesk.substring(0, 200));
            throw new Error(
              await getFriendlyCartErrorMessage(
                _deskRes,
                `Desktop sections fetch failed (HTTP ${_deskRes.status})`,
                _rawDesk
              )
            );
          }
          const sectionsData = await _deskRes.json();

          if (this.cart && typeof this.cart.renderContents === "function") {
            try {
              this.cart.renderContents({
                items: cartData.items,
                sections: sectionsData,
                total_price: cartData.total_price,
              });
            } catch (e) {
              console.error("Error rendering cart contents:", e);
              // For non-modal only, fallback to redirect on render error
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          }

          if (
            this.cart &&
            this.cart.tagName.toLowerCase() === "cart-drawer" &&
            typeof this.cart.open === "function"
          ) {
            try {
              this.cart.open(this.submitButton);
              this.cart.classList.add("animate", "active");
              this.cart.style.display = "block";
              this.cart.style.visibility = "visible";
            } catch (e) {
              console.error("Error opening cart drawer:", e);
              // For non-modal only, fallback to redirect on open error
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          } else {
            // fallback
            try {
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                bubble.dispatchEvent(new Event("click", { bubbles: true }));
              } else {
                // For non-modal only, fallback to redirect
                if (!isModalSubmit) {
                  window.location.href = "/cart";
                }
              }
            } catch (e) {
              console.error("Error triggering cart bubble:", e);
              // For non-modal only, fallback to redirect
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          }
        };

        (async () => {
          const _totalStart = performance.now();
          console.log(
            `[CART-DEBUG] === Add to Cart START === quantity=${quantity}, url=${window.location.href}, timestamp=${new Date().toISOString()}`
          );
          try {
            const addResult = await addItems(quantity);
            const renderUpdatedCartContents = () =>
              renderCartContents(addResult?.cartData || null);

            if (addResult?.partialAddMessage) {
              this.handleErrorMessage(addResult.partialAddMessage);
            }
            
            // OPTIMIZATION: Call metafield update in background (don't await) 
            // to improve perceived performance for the user.
            updateCustomerCartMetafield().catch((_metaErr) => {
              console.warn("[CART-DEBUG] updateCustomerCartMetafield failed (non-blocking):", _metaErr);
            });

            const quickAddModal = this.closest("quick-add-modal");
            const stickyVariantModal = isModalSubmit
              ? this.closest('modal-dialog[id^="StickyVariantModal-"]')
              : null;

            if (quickAddModal) {
              // Existing quick-add logic (unchanged - hides modal and waits for close event)
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      renderUpdatedCartContents,
                    );
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else if (stickyVariantModal) {

              const onModalHidden = () => {
                setTimeout(() => {
                  CartPerformance.measure(
                    "add:paint-updated-sections",
                    renderUpdatedCartContents,
                  );
                });
              };

              // Listen for 'modalClosed' event if your modal dispatches it
              document.body.addEventListener("modalClosed", onModalHidden, {
                once: true,
              });

              // Reliable fallback: MutationObserver watches for 'open' attribute removal (modal hidden)
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.attributeName === "open" &&
                    !stickyVariantModal.hasAttribute("open")
                  ) {
                    onModalHidden();
                    observer.disconnect(); // Clean up
                  }
                });
              });
              observer.observe(stickyVariantModal, { attributes: true });

              // Trigger modal hide/close
              if (stickyVariantModal.hide) {
                stickyVariantModal.hide(true); // Preferred if custom element supports it
              } else {
                // Fallback: Simulate close button click or direct DOM manipulation
                const closeButton =
                  stickyVariantModal.querySelector(
                    "#ModalClose-sticky-{{ section.id }}",
                  ) ||
                  stickyVariantModal.querySelector(
                    ".sticky-variant-modal__toggle",
                  );
                if (closeButton) {
                  closeButton.click();
                } else {
                  stickyVariantModal.removeAttribute("open");
                  stickyVariantModal.classList.add("hidden");
                  document.body.classList.remove("overflow-hidden"); // If your theme uses this for body lock
                }
              }
            } else {
              CartPerformance.measure(
                "add:paint-updated-sections",
                renderUpdatedCartContents,
              );
            }
          } catch (error) {
            const _totalEnd = performance.now();
            console.error(
              `[CART-DEBUG] === Add to Cart FAILED === error="${error.message}" totalTime=${(_totalEnd - _totalStart).toFixed(0)}ms`
            );
            console.error("Add to cart failed:", error);

            const errorMessage = error.message || "Failed to add item.";
            const isRateLimitError =
              errorMessage === TOO_MANY_REQUESTS_MESSAGE;

            const renderSubmitErrorMessage = () => {
              this.handleErrorMessage(errorMessage);

              const modal = this.closest(
                'modal-dialog[id^="StickyVariantModal-"]',
              );
              if (modal && isModalSubmit) {
                const stickyError = modal.querySelector(
                  ".sticky-error-message",
                );
                if (stickyError) {
                  stickyError.textContent =
                    errorMessage ||
                    "Sorry, could not add this item. Please try again.";
                  stickyError.style.display = "block";
                }

                const errorWrapper = modal.querySelector(
                  ".product-form__error-message-wrapper",
                );
                if (errorWrapper) {
                  errorWrapper.removeAttribute("hidden");
                  errorWrapper.style.display = "block";

                  const errorMsg = errorWrapper.querySelector(
                    ".product-form__error-message",
                  );
                  if (errorMsg) {
                    errorMsg.textContent = errorMessage;
                  }
                }
              }
            };

            if (isRateLimitError && rateLimitReloadScheduled) {
              window.setTimeout(() => {
                if (document.visibilityState === "hidden") return;
                renderSubmitErrorMessage();
              }, TOO_MANY_REQUESTS_FALLBACK_MESSAGE_DELAY_MS);
            } else {
              renderSubmitErrorMessage();
            }

            // Only unlock body scroll for non-modal cases
            if (!isModalSubmit) {
              document.body.classList.remove("overflow-hidden");
            }
          } finally {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            this.submitButton.removeAttribute("aria-disabled");
            const spinner = this.querySelector(".loading__spinner");
            if (spinner) spinner.classList.add("hidden");
            CartPerformance.measureFromEvent("add:user-action", evt);
          }
        })();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const inlineErrorWrapper = this.closest(
          ".product-form__quantity-and-buy-buttons",
        )?.querySelector(".product-form__error-message-wrapper-variant");
        const inlineErrorMessage = inlineErrorWrapper?.querySelector("span");

        if (inlineErrorWrapper && inlineErrorMessage) {
          inlineErrorWrapper.toggleAttribute("hidden", !errorMessage);
          inlineErrorWrapper.style.display = errorMessage ? "block" : "none";

          if (errorMessage) {
            inlineErrorMessage.textContent = errorMessage;
          }

          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");

          if (this.errorMessageWrapper) {
            this.errorMessageWrapper.setAttribute("hidden", "");
          }

          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const allButtons = document.querySelectorAll(
          'product-form button[type="submit"]',
        );

        allButtons.forEach((button) => {
          if (disable) {
            button.setAttribute("disabled", "disabled");
            if (text) {
              const span = button.querySelector("span");
              if (span) span.textContent = text;
            }
          } else {
            button.removeAttribute("disabled");
            const span = button.querySelector("span");
            if (span) span.textContent = window.variantStrings.addToCart;
          }
        });
      }

      // Utility method: Check if all variants are selected (scoped to context)
      isAllVariantsSelected(context = document) {
        if (context === document)
          context = this.closest("product-info") || document;
        const selectedSize = context.querySelector(
          '.size-picker input[type="radio"]:checked:not(.toggle-radio)',
        );
        const selectedLength = context.querySelector(
          '.length-picker input[type="radio"]:checked',
        );
        const sellength = context.querySelector(
          '.length-picker input[type="radio"]',
        );
        if (!context.querySelector(".size-picker")) return true;
        if (!selectedSize) {
          return false;
        }
        if (sellength && !selectedLength) {
          return false;
        }
        const selectedColor = context.querySelector(
          '.color-picker input[type="radio"]:checked',
        );
        if (context.querySelector(".color-picker") && !selectedColor) {
          return false;
        }
        return true;
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}

/**
 * MOBILE STICKY BUTTON VISIBILITY HANDLER
 * --------------------------------------------------------------------------
 * The following script manages the visibility of the mobile sticky "Add to Bag" 
 * button. On mobile devices, this button is often fixed to the bottom of the 
 * screen. However, it should be hidden when the user scrolls down to the 
 * footer to prevent it from overlapping with footer content and links.
 */

/**
 * Initializes the intersection observer to hide/show the sticky button
 * based on whether the footer is visible in the viewport.
 */
function initMobileStickyButtonVisibility() {
  // We use a global flag on window to ensure we only ever attach one listener to the scroll event
  if (window.stickyVisibilityListenerAttached) return;
  window.stickyVisibilityListenerAttached = true;

  const toggleVisibility = () => {
    // We query the button dynamically so we always have the latest one if it was replaced by AJAX
    const stickyButton = document.querySelector('.product-form__buy-buttons.add-bag.mob-qv');
    if (!stickyButton) return;

    // Calculate how far we are from the bottom of the page
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    // If we are within 640px of the bottom (the total height of the footer)
    if (pageHeight - scrollPosition < 640) {
      stickyButton.style.setProperty('display', 'none', 'important');
    } else {
      stickyButton.style.removeProperty('display');
    }
  };

  // Attach the scroll listener to the window
  window.addEventListener('scroll', toggleVisibility, { passive: true });
  window.addEventListener('resize', toggleVisibility, { passive: true });

  // Custom event for immediate sync after AJAX product updates
  document.addEventListener('product-info:loaded', toggleVisibility);

  // Initial check
  toggleVisibility();
}

// 1. Run the script once the initial HTML document has been completely loaded and parsed
document.addEventListener('DOMContentLoaded', initMobileStickyButtonVisibility);

// 2. Also run the script if the product info is updated via AJAX (e.g. variant change or quick view)
// 'product-info:loaded' is a custom event used in this theme for AJAX updates.
document.addEventListener('product-info:loaded', initMobileStickyButtonVisibility);

/**
 * STICKY ADD TO BAG: MODAL BYPASS LOGIC
 * --------------------------------------------------------------------------
 * If a variant is already selected on the main page, clicking the sticky 
 * "Add to Bag" button will submit the form directly instead of opening the 
 * selection modal.
 */
function initStickyButtonBypass() {
  document.addEventListener('click', (event) => {
    // Target the sticky button Specifically
    const button = event.target.closest('.sticky-add');
    if (!button) return;

    // Find the primary product info (the main PDP container)
    // We exclude elements with 'Modal' in the ID to ensure we target the main page
    const productInfo = document.querySelector('product-info:not([id*="Modal"])');
    if (!productInfo) return;

    // Validation logic: check if size and length pickers have active selections
    const checkMainSelection = () => {
      const sizePicker = productInfo.querySelector('.size-picker');
      const lengthPicker = productInfo.querySelector('.length-picker');
      
      const sizeOk = sizePicker ? !!sizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)') : true;
      const lengthOk = lengthPicker ? !!lengthPicker.querySelector('input[type="radio"]:checked') : true;
      
      return sizeOk && lengthOk;
    };

    if (checkMainSelection()) {
      /**
       * VARIANT IS SELECTED:
       * 1. Stop the modal from opening (using stopImmediatePropagation in capture phase)
       * 2. Trigger the ADD TO CART logic on the main product form
       */
      event.preventDefault();
      event.stopImmediatePropagation(); 

      const mainProductForm = productInfo.querySelector('product-form');
      if (mainProductForm && mainProductForm.form) {
        // Trigger a 'submit' event to run the form's AJAX handlers
        mainProductForm.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  }, { capture: true }); // Capture phase ensures we run BEFORE the ModalOpener component
}

// Initialize the bypass logic
document.addEventListener('DOMContentLoaded', initStickyButtonBypass);
document.addEventListener('product-info:loaded', initStickyButtonBypass);
